const scrollSec = () => {
  const myFunc = function() {
    const target = document.getElementsByClassName('js-scroll-sec');
    const position = Math.floor(window.innerHeight);
    let anyElementScrolled = false; // フラグを追加

    for (let i = 0; i < target.length; i++) {
      let offsetTop = Math.floor(target[i].getBoundingClientRect().top);
      if (offsetTop < position) {
        target[i].classList.add('is-scroll');
        anyElementScrolled = true; // スクロールされた要素がある
      } else {
        target[i].classList.remove('is-scroll');
      }
    }

    // フラグに基づいてbodyにクラスを付与または削除
    if (anyElementScrolled) {
      document.body.classList.add('is-scroll-sec');
    } else {
      document.body.classList.remove('is-scroll-sec');
    }
  }
  window.addEventListener('scroll', myFunc, false);
}
